import script from "./RecommendedCycles.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendedCycles.vue?vue&type=script&setup=true&lang=js"

import "./RecommendedCycles.vue?vue&type=style&index=0&id=4973b2ee&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4973b2ee"]])

export default __exports__